<template>
  <input
    type="text"
    :value="formattedValue"
    @input="onInput"
    @blur="onBlur"
    @compositionstart="onCompositionStart"
    @compositionend="onCompositionEnd"
    class="form-control"
    v-bind="$attrs"
  />
  <span class="mx-2">円</span>
</template>

<script setup>
import { computed, watch, ref } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  }
});
const emit = defineEmits(['update:modelValue', 'input', 'error']);

const internalValue = ref(props.modelValue);
const isComposing = ref(false);

const formatWithComma = (val) => {
  if (val == null || val === '') return '';
  const str = val.toString();
  const isNegative = str.startsWith('-');
  const digits = str.replace(/[^\d]/g, '');
  const formatted = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return isNegative ? `-${formatted}` : formatted;
};

watch(() => props.modelValue, (newVal) => {
  internalValue.value = newVal;
});

const toHalfWidth = (str) => {
  return str.replace(/[！-～]/g, (ch) =>
    String.fromCharCode(ch.charCodeAt(0) - 0xfee0)
  ).replace(/\u3000/g, ' ');
};

const onInput = (e) => {
  if (isComposing.value) return;

  const raw = toHalfWidth(e.target.value);

  // 数字とマイナスを一旦許可
  let cleaned = raw.replace(/[^\d-]/g, '');

  // マイナスは先頭のみ許可、2つ以上あれば削除
  cleaned = cleaned.replace(/(?!^)-/g, '');

  // フォーマット用に符号と数字を分ける
  const isNegative = cleaned.startsWith('-');
  const digits = cleaned.replace(/-/g, '');

  // カンマ区切り整形
  const formatted = formatWithComma(digits);
  e.target.value = isNegative ? `-${formatted}` : formatted;

  internalValue.value = cleaned;
  emit('update:modelValue', cleaned);
  emit('input', cleaned);
};

const onBlur = () => {
  internalValue.value = props.modelValue;
};

const onCompositionStart = () => {
  isComposing.value = true;
};
const onCompositionEnd = (e) => {
  isComposing.value = false;
  onInput(e); // IME確定後に整形再適用
};

const formattedValue = computed(() => formatWithComma(internalValue.value));
</script>

<style>
.w-third-forth{
  width: 75% !important;
}
.w-half{
  width: 50% !important;
}
.w-third{
  width: 30% !important;
}
</style>
